import { actions as rawBuilderActions } from '../../../tradebuilder-v2/modules/00-builder/state/builder-slice'
import { actions as completeActions } from '../../../tradebuilder-v2/modules/05-complete/complete-slice'
import { CompleteStepDumb } from '../../../tradebuilder-v2/modules/05-complete/templates'
import { useAppSelector } from '../../../tradebuilder-v2/store/hooks'
import { useActions } from '../../../tradebuilder-v2/store/use-actions'

export function TradeEditCompleteStep() {
  const { builder, complete, newNote, note, portfolio, strategy, topupWithdraw } = useAppSelector(
    state => state
  )
  const actions = useActions(completeActions)
  const builderActions = useActions(rawBuilderActions)
  const { approvals } = complete
  const includeTopupWithdrawApproval =
    builder.updatedAccountPendingState &&
    (builder.updatedAccountPendingState.deposit !== undefined ||
      builder.updatedAccountPendingState.withdrawal !== undefined)
  const includePortfolioApproval =
    builder.updatedAccountPendingState && builder.updatedAccountPendingState.portfolio !== undefined
  const includeStrategyApproval =
    builder.updatedAccountPendingState && builder.updatedAccountPendingState.strategy !== undefined

  // Check if all required steps are ticked
  let isAllApproved = true
  if (includeTopupWithdrawApproval) {
    isAllApproved = isAllApproved && approvals.topupWithdraw
  }
  if (includePortfolioApproval) {
    isAllApproved = isAllApproved && approvals.portfolio
  }
  if (includeStrategyApproval) {
    isAllApproved = isAllApproved && approvals.strategy
  }
  if (includePortfolioApproval || includeStrategyApproval) {
    isAllApproved = isAllApproved && approvals.fees
  }

  return (
    <CompleteStepDumb
      complete={complete}
      includeNoteApproval={false}
      includePortfolioApproval={includePortfolioApproval}
      includeStrategyApproval={includeStrategyApproval}
      isAllApproved={isAllApproved}
      newNote={newNote}
      note={note}
      portfolio={portfolio}
      strategy={strategy}
      topUpWithdraw={includeTopupWithdrawApproval ? topupWithdraw : undefined}
      onFinish={() => actions.finish()}
      onGoToStep={stepName => builderActions.goToStep(stepName)}
      onMoveBack={() => actions.moveBack()}
      onSetIsApproved={stepName => actions.setIsApproved(stepName)}
    />
  )
}
